import React, { useState } from 'react';
import useAuth from '../auth/feature/auth';
import { AdminNavigation } from './components/AdminNavigation';
import { DashboardSection } from './components/DashboardSection';

export const AdminPageContainer = () => {
  const { isAdmin } = useAuth();

  if (!isAdmin) return null;

  return (
    <div className="w-full max-w-[1400px] mx-auto py-[20px] px-[20px]">
      <AdminNavigation />
      <DashboardSection />
    </div>
  );
};
